export default "__VITE_ASSET__9e6a7b83__"